import {
  isStudent,
  isSuperAdmin,
  isTeacher,
  isUnitAdmin,
} from '@/functions/auth';
import User from '@/models/User';

export interface PermissionParams<T> {
  user?: User;
  model?: T;
}

export default abstract class Permission<T> {
  user;
  model;
  constructor({ user, model }: PermissionParams<T> = {}) {
    this.user = user;
    this.model = model;
  }

  hasSuperPrivileges(): boolean {
    return isSuperAdmin(this.user?.userType);
  }
  hasUnitPrivileges(): boolean {
    return isUnitAdmin(this.user?.userType) || this.hasSuperPrivileges();
  }
  hasTeacherPrivileges(): boolean {
    return isTeacher(this.user?.userType) || this.hasUnitPrivileges();
  }
  hasStudentPrivileges(): boolean {
    return isStudent(this.user?.userType) || this.hasTeacherPrivileges();
  }
  canEdit(): boolean {
    return this.canManage();
  }
  canDelete(): boolean {
    return this.canManage();
  }
  abstract canManage(): boolean;
}
